<template>
  <div>
    <!-- 弹窗-会员导入 -->
    <y-dialog
      title="会员导入"
      :visible="isShowDialog && isShowType == 1"
      width="700px"
			:before-close="cancelBtn"
      @comfirm="saveBtn"
      @close="cancelBtn"
      sureText="保存"
      >
      <y-tip style="margin: 0 0 20px 0;">
        <div>提示</div>
        <div>1. 单次导入数量不要超过10W条，日期格式严格按照导入模板填写</div>
				<div>2. 导入之前必须先设置会员等级规则，导入的等级名称需与等级规则中等级名称一致；</div>
				<div>3. 如果系统中已经存在该等级的会员，会覆盖原会员的等级；</div>
				<div>4. 请根据待导入会员的来源选择对应的导入模版，支持淘宝、京东、抖音会员导入；</div>
				<div>5. 使用平台账号导入会员时，请正确填写会员的平台账号，例如淘宝会员请填写ouid；</div>
      </y-tip>
			<el-form ref="form" :model="form" label-width="120px">
				<el-form-item label="所属平台：">
					<div class="displayItem">
              <el-select
                class="selectType"
                v-model="form.platform"
                placeholder="请选择"
                style="width: 186px;"
                size="small"
                @change="platformChange"
              >
                <el-option
                  v-for="item in platformList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
				</el-form-item>
				<el-form-item label="来源店铺：">
            <div class="displayItem">
              <el-select
                class="selectType"
                v-model="form.channelSellerManageId"
                placeholder="请选择"
                style="width: 186px;"
                size="small"
                v-loading="selectLoading"
              >
                <el-option
                  v-for="item in shopList"
                  :key="item.channelSellerManageId"
                  :label="item.shopTitle"
                  :value="item.channelSellerManageId"
                ></el-option>
              </el-select>
            </div>
        </el-form-item>
				<el-form-item label="数据文件：">
				
        <el-upload
          class="upload-demo"
          ref="upload"
          :action="'/api/ImportCusData/uploadBuyerFile'"
          :before-upload="beforeUpload"
          :on-success="handleUpload"
          :on-error="handleError"
          :on-remove="handleRemove"
          :on-change="handleChange"
          :file-list="fileList"
          :data="form"
          :auto-upload="false">
            <div class="uploadBox displayItem">
              <y-button type="blueLine">上传文件</y-button>
              <y-button type="blueText" style="margin-right: 8px;" @click.stop="downloadTemplate">模板下载</y-button>
              <div class="info">支持文件扩展名：.xlsx</div>
					  </div>
        </el-upload>

        <!-- <upload :disabled="disabled" v-model="fileObj" :actionUrl="'/api/ImportCusData/uploadBuyerFile'"  :uploadData="form">
          <div slot="custom" class="demo_mouseover" @click.stop="">
            <div class="uploadBox displayItem">
              <div class="downBtn">模板下载</div>
              <div class="info">支持文件扩展名：.xlsx</div>
					  </div>
          </div>
        </upload> -->

        
				</el-form-item>
			</el-form>
    </y-dialog>

		 <!-- 弹窗-积分导入 -->
		 <y-dialog
      title="积分导入"
      :visible="isShowDialog && isShowType == 2"
      width="700px"
			:before-close="cancelBtn"
      @comfirm="savePoint"
      @close="cancelBtn"
      sureText="保存"
      >
      <y-tip style="margin: 0 0 20px 0;">
        <div>提示</div>
        <div>1. 目前支持通过手机号或平台账号给系统中的会员导入积分；按平台账号导入支持淘宝、京东、抖音；</div>
				<div>2. 如果导入文件中没有设置积分有效期，则取会员卡设置的统一积分有效期；过期积分不支持导入，积分为0不允许导入；</div>
				<div>3. 请严格区分导入积分的正负值分别进行导入，如同一导入文件包含正负积分则可能导致结果有误；</div>
				<div>4. 导入的会员积分，会直接在原积分数量上累加。</div>
      </y-tip>
			<el-form ref="pointform" :model="pointform" label-width="120px">
				<el-form-item label="选择类型：">
					<el-radio-group v-model="pointform.type">
						<el-radio :label="0">手机号</el-radio>
						<el-radio :label="1">平台账号</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="来源店铺：">
            <div class="displayItem">
              <el-select
                class="selectType"
                v-model="pointform.channelSellerManageId"
                placeholder="请选择"
                style="width: 186px;"
                size="small"
                v-loading="selectLoading"
              >
                <el-option
                  v-for="item in shopList"
                  :key="item.channelSellerManageId"
                  :label="item.shopTitle"
                  :value="item.channelSellerManageId"
                ></el-option>
              </el-select>
            </div>
        </el-form-item>
				<el-form-item label="数据文件：">

        <el-upload
          class="upload-demo"
          ref="uploadPoint"
          :action="'/api/ScoresmemberIntegrate/uploadFile'"
          :before-upload="beforeUpload"
          :on-success="handleUpload"
          :on-error="handleError"
          :on-remove="handleRemove"
          :on-change="handleChange"
          :file-list="fileList"
          :data="pointform"
          :auto-upload="false">
            <div class="uploadBox displayItem">
              <y-button type="blueLine">上传文件</y-button>
              <y-button type="blueText" style="margin-right: 8px;" @click.stop="downloadpoint">模板下载</y-button>
              <div class="info">支持文件扩展名：.xlsx</div>
					  </div>
        </el-upload>

				</el-form-item>
			</el-form>
    </y-dialog>

  </div>
</template>

<script>
import Upload from "@/components/form/Upload.vue";
import { getShopList,getUploadFileRecord } from '@/api/memberMessageSystem'
import {  isScoresBindList } from "@/api/integralCenter/newMemberSystem"
export default {
  components: {
    Upload
  },
	props: {
    isShowDialog: {
      type: Boolean,
      default: false
    },
		isShowType:{
			type: Number,
		},
  },
  data() {
    return {
      form: {
        channelSellerManageId:'',
        platform:'',
        scoresCardId:'',
      },
      pointform:{
        type:0,
        channelSellerManageId:'',
      },
      platformList:[
        {
          value: 1,
          label: "淘宝"
        },
        {
          value: 2,
          label: "京东",
        },
        // {
        //   value: 3,
        //   label: "有赞",
        // },
        // {
        //   value: 4,
        //   label: "微信",
        // },
        {
          value: 5,
          label: "抖音",
        },
        // {
        //   value: 6,
        //   label: "快手",
        // }
      ],
      shopList:[],
			fileId:'',
      mobileType:'0',
      remark:'',

      process:0,
      success:'',
      fileObj: {
        name: "",
        url: "",
      },
      disabled:false,
      businessLicenseFile:'',
      sorts:[".xlsx"],
      fileList:[],
      selectLoading:false,
    };
  },
  created() {
    // 获取当前会员体系详情
    this.MemberSystemInfo = this.$store.state.MemberSystemInfo
    console.log("this.MemberSystemInfo",this.MemberSystemInfo);
    this.form.scoresCardId=this.MemberSystemInfo.scoresCardId
    this.getShopList()
  },
  computed: {
    // fileList() {
    //   if (this.fileObj.url) {
    //     return [{ name: this.fileObj.name, url: this.fileObj.url }];
    //   } else {
    //     return [];
    //   }
    // },
  },
  mounted() {
    this.form.scoresCardId=this.MemberSystemInfo.scoresCardId
    this.getShopList()
  },
  methods: {
     // 获取选择店铺
     getShopList() {
      this.selectLoading=true
     let _param={
        platform:this.form.platform,
        scoresCardId:this.form.scoresCardId,
        pageNum:1,
        pageSize:99,
      }
      isScoresBindList(_param).then((res) => {
        if (res.code == 200) {
          this.selectLoading =false
          this.shopList=res.data.dataList
        }
      });
    },
    //更改平台选择
    platformChange(){
      console.log("更改平台选择")
      this.form.channelSellerManageId=''
      this.getShopList()
    },
    // 保存弹窗
    saveBtn(){
      // this.$refs['ruleForm'].resetFields();
      if(this.form.platform !== 0){
        if(!this.form.platform){
          this.$message.warning("请选择所属平台");
          return;
        }
      }
      if(!this.form.channelSellerManageId){
        this.$message.warning("请选择来源店铺");
        return;
      }
      if(!this.fileList || this.fileList.length == 0){
        this.$message.warning("请选择上传文件");
        return;
      }
      this.$refs.upload.submit();
			this.$emit("close");
      this.fileList=[]
    },
    savePoint(){
      if(!this.pointform.channelSellerManageId){
        this.$message.warning("请选择来源店铺");
        return;
      }
      if(!this.fileList || this.fileList.length == 0){
        this.$message.warning("请选择上传文件");
        return;
      }
      this.$refs.uploadPoint.submit();
			this.$emit("close");
      this.fileList=[]
    },
    // 取消弹窗
    cancelBtn(){
      // this.$refs['ruleForm'].resetFields();
      this.$emit("close");
    },


    beforeUpload(file) {
      console.log(file);
      if (file.size > this.size * 1024 * 1024) {
        this.$message.warning(
          "所选文件大小不得超过" + this.size + "M，请重新选择"
        );
        return false;
      }
      let type = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
      console.log(type, this.sorts.indexOf(type));
      if (this.sorts.indexOf(type) < 0) {
        this.$message.warning("所选文件格式不符，请重新选择");
        return false;
      }
    },

    // 上传成功
    handleUpload(res, file, fileList) {
      if (res.code == 200) {
        this.$message.success(res.message);
      } else {
        this.$message.error(res.message);
      }
    },
    // 上传失败$message
    handleError(err) {
      console.log(err);
      this.$message.error("上传失败");
    },

    // 移除文件
    handleRemove(file, fileList) {
      console.log(file, fileList);
      if (fileList.length > 0) {
        // let fileObj = fileList[0]
        // this.$emit("changeFile", { name: fileObj.name, url: fileObj.url });
        // this.$emit("success", {});
      } else {
        this.$emit("changeFile", { name: "", url: "" });
        this.$emit("success", {});
      }
    },

    handleChange(file,_fileList){
      this.fileList = _fileList
    },

    //点击下载模板
    downloadTemplate() {
      let url = "https://yunqi-cdp-1.oss-cn-shenzhen.aliyuncs.com/templateDir/member.xlsx";
      let fileName = "导入会员模板.xls";
      let start = url.lastIndexOf(".");
      let type = url.substring(start);
      let elem = document.createElement("a");
      elem.style.display = "none";
      elem.href = url;
      elem.setAttribute("download", fileName);
      document.body.appendChild(elem);
      elem.click();
    },

    downloadpoint(){
      let url =''
      if(this.pointform.type == 1 ){
        url = "https://yunqi-cdp-1.oss-cn-shenzhen.aliyuncs.com/templateDir/point2.xlsx";
      }else{
        url = "https://yunqi-cdp-1.oss-cn-shenzhen.aliyuncs.com/templateDir/point1.xlsx";
      }

      let fileName = "导入积分模板.xls";
      let start = url.lastIndexOf(".");
      let type = url.substring(start);
      let elem = document.createElement("a");
      elem.style.display = "none";
      elem.href = url;
      elem.setAttribute("download", fileName);
      document.body.appendChild(elem);
      elem.click();
    }


  },
};
</script>

<style lang="scss" scoped>
.displayItem{
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.levelTips{
    background: #F9FCFF;
    border-radius: 6px 6px 6px 6px;

    font-size: 12px;
    font-weight: 400;
    color: #333333;
    line-height: 20px;

    padding: 12px;
    margin: 24px 0 30px 0;
    .tipsCont{
      margin-left: 20px;
    }
}
.uploadBox {
  .upload {
    box-sizing: border-box;
    width: 186px;
		height: 32px;
		background: #ECF0F8;
		border-radius: 6px 6px 6px 6px;
		opacity: 1;
		border: 1px solid #7489B5;
    transition: all .1s;
		font-size: 14px;
		font-weight: 400;
		color: #1F4287;
		text-align: center;
    &:hover {border-color: #5882FB;}
		}
		.info{
        font-size: 12px;
				font-weight: 400;
				color: #999999;
				line-height: 21px;
        cursor: default;
    }
		.downBtn{
			margin: 0 16px;
			font-size: 14px;
			font-weight: 400;
			color: #1F4287;
			line-height: 21px;
			cursor: pointer;
		}
}
.procontain{
  text-align:left;
	display:inline-block;
	width:250px;
	height:33px;
	margin-left:5px;
	float: left;
	margin-top: 20px;
  .proInfo{
    height:20px;
    line-height:20px;
    padding-right:50px;
    overflow:hidden;
    .proclose{
      float:right;
      height:20px;
      line-height:20px;
    }
  }
}
.upload_dialog {
  /deep/.el-dialog__body {
    padding: 21px 30px 0 31px;
  }
  /deep/.el-dialog__footer {
    // text-align: center !important;
  }
}
.upload_dialog {
  .item_select {
    .item_select_title {
      height: 20px;
      font-size: 14px;
      line-height: 20px;
      color: rgba(102, 102, 102, 1);
      margin-bottom: 10px;
    }
    .upload-btn {
      margin-top: 20px;
      width: 509px;
      border: 1px dashed #eeeeee;
      height: 90px;
      text-align: center;
      font-size: 12px;
      color: #999999;
      padding-top: 32px;
      box-sizing: border-box;
      i {
        font-size: 20px;
      }
      span {
        font-size: 12px;
        line-height: 21px;
        display: inline-block;
        vertical-align: top;
        margin-left: 8px;
      }
    }
  }
}
</style>